import { atom } from 'jotai';

export interface GroundClassifyTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  sourceLayerId: string;
  sourceLayerName: string;
  /** Snapshot of layer IDs that were already derived from `sourceLayerId` at
   * the moment the user clicked Run. The "new layers" produced by this run
   * are any layers with `metadata.derivedFrom === sourceLayerId` whose IDs
   * are NOT in this snapshot. Same disambiguation strategy as deviation —
   * we deliberately do NOT compare against a client-captured timestamp,
   * because client/server clock skew was previously biting that approach
   * (toast either resolved instantly against a stale derived layer or
   * spun forever).
   *
   * A ground-classification run produces TWO derived layers (POINTCLOUD
   * from the LAS child + TILE from the GEOTIFF child). Both arrive at
   * roughly the same time because postprocess inserts them together once
   * `remainingLeafJobs == 0`. The hook resolves the toast as soon as any
   * new derived layer appears — that's enough to signal "the work is
   * done" to the user; the second layer becomes visible in the layer
   * panel almost simultaneously. */
  existingDerivedLayerIds: string[];
}

export const groundClassifyTrackingAtom = atom<GroundClassifyTracker[]>([]);
